import { createApp } from 'vue'
import { VueQueryPlugin } from '@tanstack/vue-query'
import App from './App.vue'
import router from './router'
import { pinia } from './stores'
import { i18n } from './locales'

// Import global styles
import './assets/styles/index.css'

// Import Element Plus CSS variable overrides (runtime theming for dark mode)
import './assets/styles/element-theme.css'
import './assets/styles/station1.css'
import './assets/styles/library.css'

// Apply persisted theme synchronously before mount so there is no flash
// of the wrong theme on first paint. First visit follows OS preference
// (no data-theme attribute = @media prefers-color-scheme decides).
const storedTheme = window.localStorage.getItem('station1-theme')
if (storedTheme === 'light' || storedTheme === 'dark') {
  document.documentElement.setAttribute('data-theme', storedTheme)
}

const app = createApp(App)

app.use(pinia)
app.use(router)
app.use(i18n)

// Configure Vue Query
app.use(VueQueryPlugin, {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60 * 5, // 5 minutes
        gcTime: 1000 * 60 * 10, // 10 minutes (formerly cacheTime)
        retry: 1,
        refetchOnWindowFocus: true,
        refetchOnReconnect: true,
      },
      mutations: {
        retry: 0,
      },
    },
  },
})

app.mount('#app')